/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchDocumentExportReqVo
 */
export interface BatchDocumentExportReqVo {
    /**
     * 出库计划日期
     * @type {string}
     * @memberof BatchDocumentExportReqVo
     */
    expectedDate: string;
    /**
     * 用户 ID
     * @type {number}
     * @memberof BatchDocumentExportReqVo
     */
    userId: number;
    /**
     * 需要导出的订单 ID 数组；新版箱单发票按此列表放进同一张表，跨订单不合并商品
     * @type {Array<number>}
     * @memberof BatchDocumentExportReqVo
     */
    orderIds: Array<number>;
}

/**
 * Check if a given object implements the BatchDocumentExportReqVo interface.
 */
export function instanceOfBatchDocumentExportReqVo(value: object): value is BatchDocumentExportReqVo {
    if (!('expectedDate' in value) || value['expectedDate'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('orderIds' in value) || value['orderIds'] === undefined) return false;
    return true;
}

export function BatchDocumentExportReqVoFromJSON(json: any): BatchDocumentExportReqVo {
    return BatchDocumentExportReqVoFromJSONTyped(json, false);
}

export function BatchDocumentExportReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchDocumentExportReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'expectedDate': json['expectedDate'],
        'userId': json['userId'],
        'orderIds': json['orderIds'],
    };
}

export function BatchDocumentExportReqVoToJSON(json: any): BatchDocumentExportReqVo {
    return BatchDocumentExportReqVoToJSONTyped(json, false);
}

export function BatchDocumentExportReqVoToJSONTyped(value?: BatchDocumentExportReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expectedDate': value['expectedDate'],
        'userId': value['userId'],
        'orderIds': value['orderIds'],
    };
}

